import InventoryEdit from "components/Inventories/InventoryEdit";
import { Route, Routes } from "react-router-dom";
import useInventory from "hooks/useInventory";
import useRecordHistoryEvent from "hooks/useRecordHistoryEvent";

export default function InventoryEditPage() {
  const { inventory, updateInventory } = useInventory();
  const { events, fetchMoreEvents, hasMoreEvents, isLoading } = useRecordHistoryEvent({
    eventType: "inventory_events",
  });

  return (
    <Routes>
      <Route
        index
        element={
          <div>
            <InventoryEdit
              inventory={inventory}
              updateInventory={updateInventory}
              inventoryEvents={events}
              loadNextInventoryEvents={fetchMoreEvents}
              isLoadingInventoryEvents={isLoading || !hasMoreEvents}
            />
          </div>
        }
      />
    </Routes>
  );
}
